import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { Range } from './range.js';
export var EditOperation = /*#__PURE__*/function () {
  function EditOperation() {
    _classCallCheck(this, EditOperation);
  }

  _createClass(EditOperation, null, [{
    key: "insert",
    value: function insert(position, text) {
      return {
        range: new Range(position.lineNumber, position.column, position.lineNumber, position.column),
        text: text,
        forceMoveMarkers: true
      };
    }
  }, {
    key: "delete",
    value: function _delete(range) {
      return {
        range: range,
        text: null
      };
    }
  }, {
    key: "replace",
    value: function replace(range, text) {
      return {
        range: range,
        text: text
      };
    }
  }, {
    key: "replaceMove",
    value: function replaceMove(range, text) {
      return {
        range: range,
        text: text,
        forceMoveMarkers: true
      };
    }
  }]);

  return EditOperation;
}();